__turbopack_context__.v({
  "checkIcon": "Checkbox-module__Y8pSOW__checkIcon",
  "checkPartiallyIcon": "Checkbox-module__Y8pSOW__checkPartiallyIcon",
  "checkbox": "Checkbox-module__Y8pSOW__checkbox",
  "checkboxChecked": "Checkbox-module__Y8pSOW__checkboxChecked",
  "checkboxCheckedPartially": "Checkbox-module__Y8pSOW__checkboxCheckedPartially",
  "checkboxDisabled": "Checkbox-module__Y8pSOW__checkboxDisabled",
  "checkboxInput": "Checkbox-module__Y8pSOW__checkboxInput",
  "checkboxLabel": "Checkbox-module__Y8pSOW__checkboxLabel",
  "checkboxSmall": "Checkbox-module__Y8pSOW__checkboxSmall",
  "checkboxThemed": "Checkbox-module__Y8pSOW__checkboxThemed",
});
